import { Link } from "react-router-dom";
import "./religiousservices.css";
import PoojaBasket from "../../../components/common/Basket/PoojaBoasket/PoojaBasket";
import {
  useMonthlyServicesFunctions,
  useServicesCommonFunctions,
} from "../customHooks";
import moment from "moment";
import { Container, Grid } from "@mui/material";
import ServiceCard from "../../../components/common/cards/ServiceCard";
import { logEvent } from "../../../utils/analytics";
import templeJson from "../../../config/temple.json";
function MonthlyServices() {
  const { serviceData } = useMonthlyServicesFunctions();
  const isStyleOne = templeJson["Services"]?.style === 1;
  const servicestyle = {
    head: isStyleOne ? "page-header py-4 service-head-dt" : "page-header py-4 service-head-svt"
  }
  const {
    selectedDate,
    quantityCounts,
    setSelectedDate,
    handleOrderPuja,
    increaseQuantity,
    decreaseQuantity,
  } = useServicesCommonFunctions();

  const shouldDisableDate = (date, i) => {
    if (i?.sync_type !== 3) {
      const currentDate = new Date();
      const startDate = new Date(i?.start);
      const endDate = new Date(i?.end);
      currentDate.setHours(0, 0, 0, 0);
      return (
        date < currentDate ||
        date.date() < moment.utc(new Date(startDate)).format("DD") ||
        date.date() > moment.utc(new Date(endDate)).format("DD")
      );
    } else {
      const currentDate = new Date();
      if (date < currentDate) {
        return true;
      }
      const year = new Date(date).getFullYear();
      const month = new Date(date).getMonth();
      const firstDayOfMonth = new Date(year, month, 1);

      const firstDayOfWeek = firstDayOfMonth.getDay();
      const offset = (i?.days - firstDayOfWeek + 7) % 7;
      const position = Number(i?.positions.replace(/\D/g, ""));
      const firstSelectableDate = new Date(
        year,
        month,
        1 + offset + (Number(position) - 1) * 7
      );
      return (
        new Date(date).getDate() !== firstSelectableDate.getDate() ||
        new Date(date).getMonth() !== firstSelectableDate.getMonth() ||
        new Date(date).getFullYear() !== firstSelectableDate.getFullYear()
      );
    }
  };

  const handleOrderClick = (i) => {
    handleOrderPuja(i, "Monthly Service", "services/monthly");
    logEvent("Monthly Puja Request", "Request Puja Clicked", i.title);
  };

  return (
    <>
      <Container maxWidth={false} className={servicestyle?.head}>
          <h1 className="text-center service-head display-6 breadcrumb-h1">
            Monthly Services
          </h1>
          <ol className="breadcrumb justify-content-center mb-0">
            <li className="breadcrumb-item">
              <Link to="/">Home</Link>
            </li>
            <li className="breadcrumb-item">
              <Link to="/servicesattemple">Services</Link>
            </li>
            <li className="breadcrumb-item active">Monthly Services</li>
          </ol>
      </Container>
      <Container className="py-5">
        <Grid className="text-center mb-5">
          <h6 className="section-title text-center text-primary text-uppercase title-tl">
            {templeJson["templeName"]}          
          </h6>
          <h1 className="mb-3">
            <span className="text-secundary">Monthly Services</span>
          </h1>
        </Grid>
        <p>
          <strong>Please Note:</strong> The schedule may be changed due to
          special events held in temple on that day.
        </p>
        <Grid container spacing={2}>
        <Grid item xs={12} sm={12} md={9} lg={9}>
          <Grid container spacing={2}>
              {serviceData?.map((i) => (
                <Grid
                  key={i._id}
                  item
                  xs={12}
                  sm={6}
                  md={4}
                  lg={4}
                  className="equal-height"
                >
                  <ServiceCard
                    i={i ? i : []}
                    increaseQuantity={increaseQuantity}
                    decreaseQuantity={decreaseQuantity}
                    handleOrderClick={handleOrderClick}
                    selectedDate={selectedDate}
                    setSelectedDate={setSelectedDate}
                    quantityCounts={quantityCounts}
                    type={"atTemple"}
                    shouldDisableDate={shouldDisableDate}
                  />
                </Grid>
              ))}
            </Grid>
          </Grid>

          {/* basket ------------------------------------------- */}
          <Grid item xs={12} sm={12} md={3} lg={3}>
            <PoojaBasket />
          </Grid>
        </Grid>
      </Container>
    </>
  );
}

export default MonthlyServices;
